import { render, staticRenderFns } from "./LedgerBankImport.vue?vue&type=template&id=c080a694&scoped=true"
import script from "./LedgerBankImport.vue?vue&type=script&lang=js"
export * from "./LedgerBankImport.vue?vue&type=script&lang=js"
import style0 from "./LedgerBankImport.vue?vue&type=style&index=0&id=c080a694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c080a694",
  null
  
)

export default component.exports